export const profileAccordions = {
  personal_info: {
    icon: 'ic_personal info.svg',
    routerView: 'details',
    path: 'details',
    text: 'Personal Info',
  },
  protected_information: {
    icon: 'ic_protected_information.svg',
    routerView: 'protectedinformation',
    path: 'protectedinformation',
    text: 'Protected Information',
  },
  social_profiles: {
    icon: 'ic_socialprofiles.svg',
    routerView: 'socialprofiles',
    path: 'socialprofiles',
    text: 'Social Profiles',
  },
  work_experience: {
    icon: 'ic_job_history.svg',
    routerView: 'jobHistory',
    path: 'jobhistory',
    text: 'Work Experience',
  },
  passport: {
    icon: 'ic_passport.png',
    routerView: 'passport',
    path: 'passport',
    text: 'Passport',
  },
  licence: {
    icon: 'ic_licence.png',
    routerView: 'licence',
    path: 'licence',
    text: 'Licence(s)',
  },
  skills: {
    icon: 'ic_skills.svg',
    routerView: 'skills',
    path: 'skills',
    text: 'Skills/Speciality(s)',
  },
  additional_documents: {
    icon: 'ic_additional_documents.svg',
    routerView: 'additionalDocuments',
    path: 'additional-documents',
    text: 'Additional Document(s)',
  },
  my_documents: {
    icon: 'ic_additional_documents.svg',
    routerView: 'myDocuments',
    path: 'my-documents',
    text: 'My Documents',
  },
  resumes: {
    icon: 'ic_resume.svg',
    routerView: 'resume',
    path: 'resumes',
    text: 'Resume',
  },
  langauge: {
    icon: 'ic_prersonal_info.svg',
    routerView: 'language',
    path: 'language',
    text: 'Language(s)',
  },
  locale_language: {
    icon: 'ic_prersonal_info.svg',
    routerView: 'localeLanguage',
    path: 'locale-language',
    text: 'Language Settings',
  },
  education_history: {
    icon: 'ic_education_history.svg',
    routerView: 'educationHistory',
    path: 'education-history',
    text: 'Education History',
  },
  work_preference: {
    icon: 'ic_work_preference.svg',
    routerView: 'workPreference',
    path: 'workpreference',
    text: 'Work Preference',
  },
  job_preference: {
    icon: 'ic_work_preference.svg',
    routerView: 'workPreference',
    path: 'workpreference',
    text: 'Work Preference',
  },
  professional_reference: {
    icon: 'ic_professional_preference.svg',
    routerView: 'professionalReference',
    path: 'professional-reference',
    text: 'Professional References',
  },
  notification_preference: {
    icon: 'ic_notification_preference.svg',
    routerView: 'notificationPreference',
    path: 'notification-preference',
    text: 'Notification Preference',
  },
  change_password: {
    icon: 'ic_change_password.svg',
    routerView: 'updatePassword',
    path: 'update-password',
    text: 'Change Password',
  },
  discipline_specialties: {
    icon: 'ic_discipline_specialties.svg',
    routerView: 'disciplineandspecialties',
    path: 'disciplineandspecialties',
    text: 'Discipline & Specialities',
  },
  data_privacy_settings: {
    icon: 'ic_data_privacy.svg',
    routerView: 'dataprivacysettings',
    path: 'data-privacy-settings',
    text: 'Data, Privacy and Account Settings',
  },
};
